// SignalLink AI — core constants (client-side, zero external dependency)

export const ORG = {
  name: "SignalLink Protocol LLC",
  cage: "16WJ1",
  system: "SignalLink AI",
  framework: "ADA-4WM",
  architecture: "33-Layer Provenance Framework",
  crypto: "K-Crypto / SHA-256",
  analytics: "HCT-3",
  principle: "Capture → Anchor → Detect → Verify → Reconstruct",
  tagline: "Even your house was born on your foundation.",
};

export const DEFAULT_ORIGIN = "SignalLink Protocol LLC / SignalLink AI";
export const DEFAULT_FRAMEWORK = "ADA-4WM — 33-Layer Provenance Architecture";
export const GENESIS_HASH = "0".repeat(64);

// Provenance source tags — the application must always distinguish these.
export const SOURCE = {
  local: {
    code: "LOCAL",
    label: "LOCAL CRYPTOGRAPHIC EVIDENCE",
    detail: "Client-side WebCrypto / SHA-256",
  },
  simulated: {
    code: "SIMULATED",
    label: "SIMULATED / DEMO TELEMETRY",
    detail: "HCT-3 Synthetic Feed — not a real measurement",
  },
  external: {
    code: "EXTERNAL",
    label: "EXTERNALLY VERIFIED",
    detail: "Requires a real external anchor receipt (none configured)",
  },
};

export const PAYLOAD_TYPES = [
  "AI Response",
  "Document",
  "Telemetry Object",
  "System State",
  "Digital Event",
  "Test Payload",
];

export const HASH_MODES = [
  { value: "canonical", label: "CANONICAL JSON", detail: "Deterministic structured hashing (sorted keys)." },
  { value: "raw", label: "RAW TEXT", detail: "Byte/text-sensitive hashing; formatting changes the digest." },
];

// Optional adapters — intentionally disabled. Never required to use the console.
export const OPTIONAL_INTEGRATIONS = [
  { name: "External Timestamp Authority (RFC 3161)", status: "OPTIONAL INTEGRATION — NOT REQUIRED" },
  { name: "Blockchain Anchor (Ethereum RPC / wallet)", status: "OPTIONAL INTEGRATION — NOT REQUIRED" },
  { name: "Cloud Evidence Sync (Supabase / Firebase / AWS)", status: "OPTIONAL INTEGRATION — NOT REQUIRED" },
  { name: "External Identity Provider (OAuth / SSO)", status: "OPTIONAL INTEGRATION — NOT REQUIRED" },
  { name: "LLM Assist (OpenAI / Google)", status: "OPTIONAL INTEGRATION — NOT REQUIRED" },
];

export const NAV = [
  { id: "dashboard", label: "Dashboard", path: "/", icon: "LayoutDashboard" },
  { id: "workflow", label: "Full Workflow", path: "/workflow", icon: "Workflow" },
  { id: "anchor", label: "Anchor Event", path: "/anchor", icon: "Anchor" },
  { id: "verify", label: "Verify & Tamper Check", path: "/verify", icon: "ShieldCheck" },
  { id: "ada4wm", label: "ADA-4WM (33-Layer)", path: "/ada4wm", icon: "LayoutGrid" },
  { id: "hct3", label: "HCT-3 Simulator", path: "/hct3", icon: "Activity" },
  { id: "kcrypto", label: "K-Crypto (SHA-256)", path: "/kcrypto", icon: "KeyRound" },
  { id: "statecapture", label: "State Capture", path: "/state-capture", icon: "Camera" },
  { id: "driftmonitor", label: "Drift Monitor", path: "/drift", icon: "Waves" },
  { id: "reconstruction", label: "Reconstruction & Replay", path: "/reconstruction", icon: "History" },
  { id: "vault", label: "Evidence Vault", path: "/vault", icon: "Database" },
  { id: "evidencepack", label: "Evidence Pack (PDF)", path: "/evidence-pack", icon: "FileText" },
  { id: "architecture", label: "Architecture Explorer", path: "/architecture", icon: "Network" },
  { id: "about", label: "About SignalLink", path: "/about", icon: "Info" },
];
